import { z } from 'zod';

export const ReviewTranslationDTO = z.object({
    translations: z.array(
        z.object({
            label: z.string().nullish(),
            text: z.string(),
        }),
    ),
});

export type ReviewTranslationDTO = z.infer<typeof ReviewTranslationDTO>;
